<div class="grid-container margin-top wrapper margin-bottom-large">
  @if (!dataLoading?.value) {
    <div>
      <form [formGroup]="form">
        <div class="grid-x grid-margin-x">
          <div class="cell small-6 large-6 medium-6">
            <div class="grid-x">
              <div class="cell small-12 medium-12 large-12">
                <span class="bold minor-margin-right">Company Name: </span>{{ organizationName }}
              </div>
              <div class="cell small-12 medium-12 large-12">
                @if (organization != null) {
                  <span class="bold minor-margin-right">RICS Owner #:</span><a [routerLink]="['/common/organization', organization.id]" target="_blank" href="">{{ organizationId }}</a>
                } @else {
                  <span class="bold minor-margin-right">RICS Owner #:</span><a (click)="showOrgNotFound()">{{ organizationId}}</a>
                }
              </div>
              <div class="cell small-12 medium-12 large-12">
                <span class="bold minor-margin-right">RBDMS Owner #:</span>{{ historicOwnerNumber }}
              </div>
              <div class="cell small-12 medium-12 large-12 bold">
                Issue Details
              </div>
            </div>
          </div>
          <div class="cell small-6 medium-6 large-6">
            <div class="grid-x">
              <div class="cell small-6 medium-7 large-7 bold text-align-right padding-right-small">
                Status:
              </div>
              <div class="cell small-6 medium-5 large-5">
                <select formControlName="status">
                  @for (s of statusList; track s) {
                    <option [ngValue]="s.id">{{s.text}}</option>
                  }
                </select>
              </div>
              <div class="cell small-6 medium-7 large-7` bold text-align-right padding-right-small">
                Date of Next Action<span [ngClass]="{ 'red' : dateNextInvalid }">*</span>:
              </div>
              <div class="cell small-6 medium-5 large-5">
                <common-date-picker [id]="'dateOfNextAction'" [daysPast]="1" [formGroup]="form?.get('dateOfNextAction')" (dateUpdated)="nextActionDateChanged($event)"></common-date-picker>
              </div>
              <div class="cell small-6 medium-6 large-6 text-align-right">
                <div class="checkbox">
                  <input class="show-for-sr" id="preletter" type="checkbox" formControlName="preLetterSent" />
                  <label for="preletter">
                    Pre-Letter Sent? <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
                  </label>
                </div>
              </div>
              <div class="cell small-3 medium-3 large-3 text-align-right">
                <div class="checkbox">
                  <input class="show-for-sr" id="letter1" type="checkbox" formControlName="letter1Sent" />
                  <label for="letter1">
                    Letter 1 Sent? <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
                  </label>
                </div>
              </div>
              <div class="cell small-3 medium-3 large-3 text-align-center">
                <div class="checkbox">
                  <input class="show-for-sr" id="letter2" type="checkbox" formControlName="letter2Sent" />
                  <label for="letter2">
                    Letter 2 Sent? <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="cell small-12 medium-12 large-12 padding-left">
            <div class="grid-x grid-margin-x">
              <div class="cell small-12 medium-4 large-4">
                <span class="bold minor-margin-right">Date Created:</span>{{issue?.creationDate | date: 'MMMM d, y' }}
              </div>
              <div class="cell small-12 medium-3 large-2">
                <span class="bold minor-margin-right">Due Date:</span>{{issue?.dateDue | date: 'MMMM d, y' }}
              </div>
              <div class="cell small-12 medium-5 large-6">
                <span class="bold minor-margin-right">Resolution Date:</span>{{issue?.resolutionDate | date: 'MMMM d, y' }}
              </div>
              <div class="cell small-12 medium-4 large-4">
                <span class="bold minor-margin-right">Program Area:</span>{{issue?.issueOwner}}
              </div>
              <div class="cell small-12 medium-3 large-2">
                <span class="bold minor-margin-right">Issue Code:</span>{{issue?.typeId}}
              </div>
              <div class="cell small-12 medium-5 large-6">
                <span class="bold minor-margin-right">Issue Description:</span>{{issue?.description}}
              </div>
              <div class="cell small-6 medium-3 large-3">
                <span class="bold">Organization Name at Time of Issue:</span>
              </div>
              <div class="cell small-6 medium-3 large-3">
                {{issue?.organizationNameAtTimeOfIssue}}
              </div>
              <div class="cell small-12 medium-6 large-6">
                <span class="bold minor-margin-right">RICS Registered?</span>{{organizationRegistered}}
              </div>
              <div class="cell small-6 medium-3 large-3">
                <span class="bold">RICS Organization # at Time of Issue:</span>
              </div>
              <div class="cell small-6 medium-3 large-3">
                <a [routerLink]="['/common/organization', issue.organizationId]" target="_blank" href="">{{ issue?.organizationId }}</a>
              </div>
              <div class="cell small-12 medium-6 large-6">&nbsp;</div>
              <div class="cell large-3 medium-3 small-6">
                <span class="bold">RBDMS Owner # at Time of Issue:</span>
              </div>
              <div class="cell small-6 medium-3 large-3">
                {{issue?.legacyId}}
              </div>
              @if (issue?.wellId?.length > 0) {
                <div class="cell small-12 medium-6 large-6">
                  <span class="bold minor-margin-right">Date of Last Inspection:</span>{{issue?.mostRecentInspectionDate | date: 'MMMM, d, y'}}
                </div>
                <div class="cell small-12 medium-6 large-6">
                  <span class="bold minor-margin-right">Last Inspected By:</span>{{lastInspector?.displayName}}
                </div>
              }
              <div class="cell small-12 medium-6 large-6">
                <span class="bold minor-margin-right">Assigned To:</span>{{assignedTo?.displayName}}
              </div>
              <div class="cell small-12 medium-6 large-6">
                <span class="bold minor-margin-right">Extension Granted:</span>{{extensionGranted}}
              </div>
            </div>
          </div>
          @if (issue?.wellId?.length > 0) {
            <div class="cell small-12 medium-12 large-12 bold">
              API Number / Well Details:
            </div>
            <div class="cell small-12 medium-12 large-12 padding-left padding-right">
              <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="affectedWells | async" aria-label="Review Issue"></ag-grid-angular>
            </div>
          }
        </div>
        <report-notes [label]="'Comments'" [notes]="issue?.issueNotes" (errorOccurred)="handleError($event)" (noteAdded)="addNote($event)" (noteDeleted)="deleteNote($event)" [reportId]="issue?.id"></report-notes>
        <div class="grid-x grid-margin-x">
          <div class="cell large-2 small-6 medium-2 bold text-align-right">
            Next Step:<span [ngClass]="{ 'red' : form?.get('nextStep').invalid }" class="bold">*</span>
          </div>
          <div class="cell large-3 small-6 medium-3">
            <select formControlName="nextStep" (ngModelChange)="nextStepChanged($event)">
              @for (s of stepList; track s) {
                <option [ngValue]="s.id">{{s.text}}</option>
              }
            </select>
          </div>
        </div>
        <div>
          @switch (true) {
            @case (nextStepValue == steps.KeepWorking) {
              <div class="grid-x grid-margin-x padding-left" [formGroup]="keepWorkingForm">
                <div class="small-12 large-6 medium-6">
                  <div class="grid-x grid-margin-x padding-right">
                    <div class="cell small-6 large-4 medium-4 text-align-right padding-right bold">
                      Owner Contested?
                    </div>
                    <div class="cell small-6 medium-8 large-8">
                      <select formControlName="contested" (ngModelChange)="contestedChanged($event)">
                        @for (yn of yesNoOptions; track yn) {
                          <option [ngValue]="yn.id">{{yn.text}}</option>
                        }
                      </select>
                    </div>
                    @if (form?.get('keepWorkingForm')?.get('contested')?.value === 'Yes') {
                      <div class="cell small-6 medium-4 large-4 text-align-right padding-right bold">
                        Date Contested<span [ngClass]="{ 'red' : dateContestedInvalid }" class="bold">*</span>:
                      </div>
                      <div class="cell small-6 medium-8 large-8">
                        <common-date-picker [id]="'dateContested'" [formGroup]="form?.get('keepWorkingForm')?.get('dateContested')"></common-date-picker>
                      </div>
                      <div class="cell small-12 medium-12 large-12 text-align-right padding-right bold">
                        Contested Reason<span [ngClass]="{ 'red': form?.get('keepWorkingForm').get('contestedReason')?.invalid }">*</span>:
                      </div>
                      <div class="cell small-12 medium-12 large-12">
                        <text-editor (formBuilt)="contestedFormBuilt($event)" [required]="true" [content]="issue?.contestedReason"></text-editor>
                      </div>
                    }
                  </div>
                </div>
                <div class="small-12 large-6 medium-6">
                  <div class="grid-x grid-margin-x">
                    <div class="cell small-6 medium-4 large-4">
                      Extension Requested:
                    </div>
                    <div class="cell small-6 medium-8 large-8">
                      <select formControlName="extensionRequested">
                        @for (yn of yesNoOptions; track yn) {
                          <option [ngValue]="yn.id">{{yn.text}}</option>
                        }
                      </select>
                    </div>
                    @if (keepWorkingForm?.get('extensionRequested')?.value === 'Yes') {
                      <div class="cell small-6 medium-4 large-4">
                        Extension Granted?
                      </div>
                      <div class="cell small-6 medium-8 large-8">
                        <div class="checkbox">
                          <input class="show-for-sr" id="grantExtension" type="checkbox" formControlName="extensionGranted" (ngModelChange)="extensionGrantedChanged($event)" />
                          <label for="grantExtension">
                            <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
                          </label>
                        </div>
                      </div>
                      <div class="cell small-6 medium-4 large-4">
                        Extension Expiration<span [ngClass]="{ 'red' : extensionDateInvalid }" class="bold">*</span>:
                      </div>
                      <div class="cell small-6 medium-8 large-8">
                        <common-date-picker [id]="'extensionExpiration'" [daysPast]="1" [formGroup]="form?.get('keepWorkingForm')?.get('extensionExpiration')"></common-date-picker>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            @case (nextStepValue == steps.Close) {
              <div class="grid-x grid-margin-x padding-left" [formGroup]="form?.get('resolvedForm')">
                <div class="cell small-6 medium-3 large-3 text-align-right bold">
                  Resolution Date<span [ngClass]="{ 'red': resolutionDateInvalid }">*</span>
                </div>
                <div class="cell small-3 medium-3 large-3">
                  <common-date-picker [id]="'resolvedDate'"  [formGroup]="form?.get('resolvedForm')?.get('resolvedDate')"></common-date-picker>
                </div>
                <div class="cell small-3 medium-6 large-6">&nbsp;</div>
              </div>
            }
            @case (nextStepValue == steps.Escalate) {
              <div class="grid-x grid-margin-x padding-left" [formGroup]="form?.get('escalationForm')">
                @if (isContested) {
                  <div class="small-6 medium-6 large-6">
                    <div class="grid-x grid-margin-x padding-right">
                      <div class="cell small-6 large-4 medium-4 text-align-right padding-right bold">
                        Owner Contested?
                      </div>
                      <div class="cell small-6 medium-8 large-8">
                        <select formControlName="contested" (ngModelChange)="contestedChanged($event)">
                          @for (yn of yesNoOptions; track yn) {
                            <option [ngValue]="yn.id">{{yn.text}}</option>
                          }
                        </select>
                      </div>
                      @if (form?.get('keepWorkingForm')?.get('contested')?.value === 'Yes') {
                        <div class="cell small-6 medium-4 large-4 text-align-right padding-right bold">
                          Date Contested<span [ngClass]="{ 'red' : dateContestedInvalid }" class="bold">*</span>:
                        </div>
                        <div class="cell small-6 medium-8 large-8">
                          <common-date-picker [id]="'dateContested'" [formGroup]="form?.get('keepWorkingForm')?.get('dateContested')"></common-date-picker>
                        </div>
                        <div class="cell small-12 medium-12 large-12 text-align-right padding-right bold">
                          Contested Reason<span [ngClass]="{ 'red': form?.get('keepWorkingForm').get('contestedReason')?.invalid }">*</span>:
                        </div>
                        <div class="cell small-12 medium-12 large-12">
                          <text-editor (formBuilt)="contestedFormBuilt($event)" [required]="true" [content]="issue?.contestedReason"></text-editor>
                        </div>
                      }
                    </div>
                  </div>
                }
                <div [ngClass]="{ 'small-12 large-12 medium-12' : !isContested, 'small-12 medium-6 large-6': isContested }">
                  <div class="grid-x">
                    <div class="cell small-6 medium-4 large-4 text-align-right padding-right-small bold">
                      Escalation Method:<span [ngClass]="{ 'red' : form?.get('escalationForm')?.get('escalationMethod').invalid }">*</span>
                    </div>
                    <div class="cell small-6 medium-8 large-8">
                      <select formControlName="escalationMethod" (ngModelChange)="escalationMethodChanged($event)">
                        @for (opt of escalationOptions; track opt) {
                          <option [ngValue]="opt.id">{{opt.text}}</option>
                        }
                      </select>
                    </div>
                    @switch (form?.get('escalationForm')?.get('escalationMethod').value) {
                      @case (escalationMethods.ChiefsOrder) {
                        <div class="cell small-6 medium-4 large-4 padding-right-small text-align-right">
                          Chief's Order Number:
                        </div>
                        <div class="cell small-6 medium-8 large-8">
                          <input type="text" formControlName="chiefsOrderNumber" [ngClass]="{ 'constrain' : !isContested }" />
                        </div>
                        <div class="cell small-6 medium-4 large-4 padding-right-small text-align-right">
                          Date Issued:
                        </div>
                        <div class="cell small-6 medium-8 large-8">
                          <common-date-picker [id]="'dateChiefsOrderIssued'" [formGroup]="form?.get('escalationForm')?.get('dateChiefsOrderIssued')"></common-date-picker>
                        </div>
                        @if (previousDecision?.length > 0) {
                          <div class="cell small-6 medium-4 large-4 padding-right-small text-align-right">
                            Previous Decision:
                          </div>
                          <div class="cell small-6 medium-8 large-8">
                            {{ previousDecision }}
                          </div>
                        }
                      }
                      @case (escalationMethods.ComplianceNotice) {
                        <div class="cell small-6 medium-4 large-4 padding-right-small text-align-right">
                          Compliance Notice #:
                        </div>
                        <div class="cell small-6 medium-8 large-8">
                          <input type="text" formControlName="complianceNoticeNumber" [ngClass]="{ 'constrain' : !isContested }" />
                        </div>
                        <div class="cell small-6 medium-4 large-4 padding-right-small text-align-right">
                          Date Issued:
                        </div>
                        <div class="cell small-6 medium-8 large-8 ">
                          <common-date-picker [id]="'complianceNoticeIssued'" [formGroup]="form?.get('escalationForm')?.get('complianceNoticeIssued')"></common-date-picker>
                        </div>
                        <div class="cell small-6 medium-4 large-4 padding-right-small text-align-right">
                          Date Due<span [ngClass]="{ 'red' : escalationForm?.get('complianceNoticeDueDate')?.get('datePicker').invalid }" class="bold">*</span>:
                        </div>
                        <div class="cell small-6 medium-8 large-8">
                          <common-date-picker [id]="'complianceNoticeDueDate'" [formGroup]="form?.get('escalationForm')?.get('complianceNoticeDueDate')"></common-date-picker>
                        </div>
                      }
                      @case (escalationMethods.AttorneyGeneral) {
                        <div class="cell small-6 medium-4 large-4 padding-right-small text-align-right">
                          Referral #:
                        </div>
                        <div class="cell small-6 medium-8 large-8">
                          <input type="text" formControlName="referralNumber" [ngClass]="{ 'constrain' : !isContested }" />
                        </div>
                        <div class="cell small-6 medium-4 large-4 padding-right-small text-align-right">
                          Referral Issued:
                        </div>
                        <div class="cell small-6 medium-8 large-8">
                          <common-date-picker [id]="'referralDate'" [formGroup]="form?.get('escalationForm')?.get('referralDate')"></common-date-picker>
                        </div>
                      }
                      @case (escalationMethods.ComplianceAgreement) {
                        <div class="cell small-6 medium-4 large-4 text-align-right padding-right-small">
                          Compliance Agreement #:
                        </div>
                        <div class="cell small-6 medium-8 large-8">
                          <input type="text" formControlName="complianceAgreementNumber" [ngClass]="{ 'constrain' : !isContested }" />
                        </div>
                        <div class="cell small-6 medium-4 large-4 text-align-right padding-right-small">
                          Date Issued:
                        </div>
                        <div class="cell small-6 medium-8 large-8">
                          <common-date-picker [id]="'complianceAgreementIssued'" [formGroup]="form?.get('escalationForm')?.get('complianceAgreementIssued')"></common-date-picker>
                        </div>
                        <div class="cell small-6 medium-4 large-4 padding-right-small text-align-right">
                          Date Due<span [ngClass]="{ 'red' : escalationForm?.get('complianceAgreementDueDate')?.get('datePicker')?.invalid }" class="bold">*</span>:
                        </div>
                        <div class="cell small-6 medium-8 large-8">
                          <common-date-picker [id]="'complianceAgreementDueDate'" [formGroup]="form?.get('escalationForm')?.get('complianceAgreementDueDate')"></common-date-picker>
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
            }
            @case (nextStepValue == steps.PreLetter || nextStepValue == steps.Letter1 || nextStepValue == steps.Letter2 || nextStepValue == steps.ComplianceNotice1 || nextStepValue == steps.ComplianceNotice2) {
              <div class="grid-x grid-margin-x" formGroupName="lettersForm">
                @switch (nextStepValue) {
                  @case (steps.PreLetter) {
                    <div class="cell small-6 medium-3 large-3 text-align-right bold padding-right">
                      Document Generated:
                    </div>
                    <div class="cell small-6 medium-9 large-9">
                      <textarea type="" formControlName="preletter"></textarea>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Date Mailed:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'preletterMailed'" [formGroup]="form?.get('lettersForm')?.get('preletterMailed')"></common-date-picker>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Date Received:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'preletterReceived'" [formGroup]="form?.get('lettersForm')?.get('preletterReceived')"></common-date-picker>
                    </div>
                  }
                  @case (steps.Letter1) {
                    <div class="cell small-6 medium-3 large-3 text-align-right bold padding-right">
                      Document Generated:
                    </div>
                    <div class="cell small-6 medium-9 large-9">
                      <textarea type="" formControlName="letter1"></textarea>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Due Date:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'letter1DueDate'" [daysPast]="1" [formGroup]="form?.get('lettersForm')?.get('letter1DueDate')"></common-date-picker>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Expiration Date:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'letter1ExpirationDate'" [daysPast]="1" [formGroup]="form?.get('lettersForm')?.get('letter1ExpirationDate')"></common-date-picker>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Date Mailed:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'letter1Mailed'" [formGroup]="form?.get('lettersForm')?.get('letter1Mailed')"></common-date-picker>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Date Received:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'letter1Received'" [formGroup]="form?.get('lettersForm')?.get('letter1Received')"></common-date-picker>
                    </div>
                  }
                  @case (steps.Letter2) {
                    <div class="cell small-6 medium-3 large-3 text-align-right bold padding-right">
                      Document Generated:
                    </div>
                    <div class="cell small-6 medium-9 large-9">
                      <textarea type="" formControlName="letter2"></textarea>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Date Mailed:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'letter2Mailed'" [formGroup]="form?.get('lettersForm')?.get('letter2Mailed')"></common-date-picker>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Date Date Received:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'letter2Received'" [formGroup]="form?.get('lettersForm')?.get('letter2Received')"></common-date-picker>
                    </div>
                  }
                  @case (steps.ComplianceNotice1) {
                    <div class="cell small-6 medium-3 large-3 text-align-right bold padding-right">
                      Document Generated:
                    </div>
                    <div class="cell small-6 medium-9 large-9">
                      <textarea type="" formControlName="complianceNotice1"></textarea>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Expiration Date:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'complianceNotice1ExpirationDate'" [daysPast]="1" [formGroup]="form?.get('lettersForm')?.get('complianceNotice1ExpirationDate')"></common-date-picker>
                    </div>
                    <div class="cell small-12 large-6 medium-6">&nbsp;</div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Date Mailed:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'complianceNotice1Mailed'" [formGroup]="form?.get('lettersForm')?.get('complianceNotice1Mailed')"></common-date-picker>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Date Received:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'complianceNotice1Receieved'" [formGroup]="form?.get('lettersForm')?.get('complianceNotice1Received')"></common-date-picker>
                    </div>
                  }
                  @case (steps.ComplianceNotice2) {
                    <div class="cell small-6 medium-3 large-3 text-align-right bold padding-right">
                      Document Generated:
                    </div>
                    <div class="cell small-6 medium-9 large-9">
                      <textarea type="" formControlName="complianceNotice2"></textarea>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Date Mailed:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'complianceNotice2Mailed'" [formGroup]="form?.get('lettersForm')?.get('complianceNotice2Mailed')"></common-date-picker>
                    </div>
                    <div class="cell small-6 large-3 medium-3 text-align-right bold padding-right">
                      Date Received:
                    </div>
                    <div class="cell small-6 large-3 medium-3">
                      <common-date-picker [id]="'complianceNotice2Received'" [formGroup]="form?.get('lettersForm')?.get('complianceNotice2Received')"></common-date-picker>
                    </div>
                  }
                }
              </div>
            }
          }
        </div>
        <div class="grid-x grid-margin-x margin-top">
          <div class="cell large-12 medium-12 small-12 text-align-center">
            @if (isApproveForm) {
              <span class="minor-margin-right">
                <button class="button" (click)="decide(true)" [disabled]="form?.invalid">Approve</button>
              </span>
              <span class="minor-margin-right">
                <button class="button" (click)="decide(false)" [disabled]="form?.invalid">Return</button>
              </span>
            }
            <span class="minor-margin-right">
              <button class="button" (click)="save()" [disabled]="form?.invalid">Save</button>
            </span>
            <span class="minor-margin-left minor-margin-right">
              <button class="button" (click)="cancel()">Cancel</button>
            </span>
          </div>
        </div>
        <reassign-issue [assignee]="assignedTo" (throwError)="handleError($event)" (assignedUser)="assignReviewer($event)"></reassign-issue>
      </form>
    </div>
  } @else {
    <div class="grid-x grid-margin-x">
      <div class="cell large-12 medium-12 small-12">
        <text-loader [run]="dataLoading.value" [tickType]="'.'" [text]="'Loading Issue.. please wait'" [interval]="1000"></text-loader>
      </div>
    </div>
  }
</div>


